// Syft ACP - Core <https://github.com/Syft-Application/syft2acp>
// © Syft Online Limited

import * as types from './action-types'

/**
 * Initiates a point transactions list fetching process.
 * @param {number} workerID Worker ID
 * @param {Object} options Other options
 */
export function fetchPointTransactions(workerID, options) {
  return { type: types.POINT_TRANSACTIONS_FETCH_BEGIN, workerID, options }
}
